import type { Link } from '@wix/document-services-types';

import { ExternalDataHandler } from './ExternalDataHandler';
import { ExternalStylesHandler } from './ExternalStylesHandler';
import { ExternalStateHandler } from './ExternalStateHandler';
import { ExternalPresetsHandler } from './ExternalPresetsHandler';
import { ExternalResolvedDataHandler } from './ExternalResolvedDataHandler';
import { ExternalStageHandler } from './ExternalStageHandler';
import { ExternalLayoutHandler } from './ExternalLayoutHandler';
import { ExternalPropsHandler } from './ExternalPropsHandler';
import { ExternalProvidersHandler } from './ExternalProvidersHandler';
import { ExternalBindingsHandler } from './ExternalBindingsHandler';
import { ExternalSlotsHandler } from './ExternalSlotsHandler';

import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import { DependencyToken } from '../dependencies';

export class ManifestQueryAPI extends AbstractExternalAPIHandler {
  #handlerParameters = [
    this.dependenciesContributor,
    this.editorPointerAPI,
    this.manifestStore,
    this.manifestChangeDetection,
    this.manifestServiceFlags,
    this.manifestServiceStats,
  ] as const;

  public readonly data = new ExternalDataHandler(...this.#handlerParameters);

  public readonly styles = new ExternalStylesHandler(
    ...this.#handlerParameters,
  );

  public readonly presets = new ExternalPresetsHandler(
    ...this.#handlerParameters,
  );

  public readonly resolvedData = new ExternalResolvedDataHandler(
    ...this.#handlerParameters,
  );

  public readonly state = new ExternalStateHandler(...this.#handlerParameters);

  public readonly stage = new ExternalStageHandler(...this.#handlerParameters);

  public readonly layout = new ExternalLayoutHandler(
    ...this.#handlerParameters,
  );

  public readonly props = new ExternalPropsHandler(...this.#handlerParameters);

  public readonly providers = new ExternalProvidersHandler(
    ...this.#handlerParameters,
  );

  public readonly bindings = new ExternalBindingsHandler(
    ...this.#handlerParameters,
  );

  public readonly slots = new ExternalSlotsHandler(...this.#handlerParameters);

  resolveLinkDisplayName(link: Link) {
    if (
      !this.dependenciesContributor.has(
        DependencyToken.LINK_DISPLAY_NAME_RESOLVE,
      )
    ) {
      return null;
    }

    const getLinkDisplayName = this.dependenciesContributor.get(
      DependencyToken.LINK_DISPLAY_NAME_RESOLVE,
    );

    return getLinkDisplayName(link);
  }
}

export class ManifestResolverAPI extends AbstractExternalAPIHandler {
  #handlerParameters = [
    this.dependenciesContributor,
    this.editorPointerAPI,
    this.manifestStore,
    this.manifestChangeDetection,
    this.manifestServiceFlags,
    this.manifestServiceStats,
  ] as const;

  public readonly state = new ExternalStateHandler(...this.#handlerParameters);

  public readonly stage = new ExternalStageHandler(...this.#handlerParameters);
}
